export const READING_FONTS = [
  {
    key: 'inter',
    displayName: 'Inter',
    googleFamily: null,
    category: 'sans-serif',
  },
  {
    key: 'open_sans',
    displayName: 'Open Sans',
    googleFamily: 'Open+Sans',
    category: 'sans-serif',
  },
  { key: 'lora', displayName: 'Lora', googleFamily: 'Lora', category: 'serif' },
  {
    key: 'merriweather',
    displayName: 'Merriweather',
    googleFamily: 'Merriweather',
    category: 'serif',
  },
  {
    key: 'eb_garamond',
    displayName: 'EB Garamond',
    googleFamily: 'EB+Garamond',
    category: 'serif',
  },
  {
    key: 'literata',
    displayName: 'Literata',
    googleFamily: 'Literata',
    category: 'serif',
  },
  {
    key: 'noto_serif',
    displayName: 'Noto Serif',
    googleFamily: 'Noto+Serif',
    category: 'serif',
  },
  {
    key: 'source_serif_4',
    displayName: 'Source Serif 4',
    googleFamily: 'Source+Serif+4',
    category: 'serif',
  },
  {
    key: 'crimson_text',
    displayName: 'Crimson Text',
    googleFamily: 'Crimson+Text',
    category: 'serif',
  },
  {
    key: 'libre_baskerville',
    displayName: 'Libre Baskerville',
    googleFamily: 'Libre+Baskerville',
    category: 'serif',
  },
  {
    key: 'roboto_slab',
    displayName: 'Roboto Slab',
    googleFamily: 'Roboto+Slab',
    category: 'serif',
  },
  {
    key: 'pt_serif',
    displayName: 'PT Serif',
    googleFamily: 'PT+Serif',
    category: 'serif',
  },
  {
    key: 'bitter',
    displayName: 'Bitter',
    googleFamily: 'Bitter',
    category: 'serif',
  },
  {
    key: 'alegreya',
    displayName: 'Alegreya',
    googleFamily: 'Alegreya',
    category: 'serif',
  },
  {
    key: 'cormorant_garamond',
    displayName: 'Cormorant Garamond',
    googleFamily: 'Cormorant+Garamond',
    category: 'serif',
  },
  {
    key: 'spectral',
    displayName: 'Spectral',
    googleFamily: 'Spectral',
    category: 'serif',
  },
];

export const READING_FONT_MAP = Object.fromEntries(
  READING_FONTS.map((f) => [f.key, f]),
);

export const DEFAULT_READING_FONT = 'inter';
